import React, { useState } from 'react';
import { motion } from 'framer-motion';
import TrackingButton from '../TrackingButton';
import HeatmapTracking from '../HeatmapTracking';
import ContactPopup from '../ContactPopup';

const EnhancedHero = () => {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);

  const openContactForm = (e) => {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };

  const closeContactForm = () => {
    setIsContactPopupOpen(false);
  };

  return (
    <HeatmapTracking elementName="hero_section">
      <section className="relative min-h-screen flex items-center justify-center pt-16">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1579621970588-a35d0e7ab9b6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" 
            alt="Financial background" 
            className="w-full h-full object-cover" 
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/80"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 z-10 flex flex-col md:flex-row items-center">
          <motion.div
            className="w-full md:w-1/2 text-white mb-12 md:mb-0"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Snow's Tax & Financial
            </h1>
            <p className="text-xl md:text-2xl mb-10">
              "You worked hard for it, & we'll help you keep it. Together, we can make your money work hard for what you value most in life."
            </p>
            <div className="flex flex-wrap gap-4">
              <TrackingButton
                href="https://lunacal.ai/simeon-snow"
                target="_blank"
                rel="noopener noreferrer"
                trackingName="Hero Schedule Appointment"
                trackingCategory="CTA Buttons"
                className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-medium py-3 px-6 rounded-lg transition-all shadow-lg hover:shadow-xl"
              >
                Schedule Appointment
              </TrackingButton>
              <TrackingButton
                onClick={openContactForm}
                trackingName="Hero Contact Us"
                trackingCategory="CTA Buttons"
                className="bg-gradient-to-r from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white font-medium py-3 px-6 rounded-lg transition-all shadow-lg hover:shadow-xl"
              >
                Contact Us
              </TrackingButton>
            </div>
          </motion.div>

          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="relative mx-auto">
              <img 
                src="https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d2a316b9e9dfbd1cf2e6f1_Simeon%20Snow.jpg" 
                alt="Simeon Snow" 
                className="rounded-lg shadow-xl w-full h-full object-cover" 
              />
            </div>
          </motion.div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-32 left-10 w-20 h-20 bg-blue-500/20 rounded-full animate-float"></div>
        <div className="absolute bottom-32 right-10 w-32 h-32 bg-blue-400/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>

      {/* Contact Popup */}
      <ContactPopup isOpen={isContactPopupOpen} onClose={closeContactForm} />
    </HeatmapTracking>
  );
};

export default EnhancedHero;